import { stableKey } from '@wix/gg-components';

export const apiKeys = {
  mutations: {
    createSitelessMetasite: () => stableKey(['api', 'createSitelessMetasite']),
    createSitelessSiteFromTemplate: () => stableKey(['api', 'createSitelessSiteFromTemplate']),
    initStore: () => stableKey(['api', 'initStore']),
    setupProducts: () => stableKey(['api', 'setupProducts']),
    suggestStoreName: () => stableKey(['api', 'suggestStoreName']),
    setupStoreInitialization: () => stableKey(['api', 'setupStoreInitialization']),
    updateSiteSettings: () => stableKey(['api', 'updateSiteSettings']),
    publishSite: () => stableKey(['api', 'publishSite']),
    connectPaymentProvider: () => stableKey(['api', 'connectPaymentProvider']),
    launchStore: () => stableKey(['api', 'launchStore']),
  },
  queries: {
    getPaymentAggregators: () => stableKey(['api', 'getPaymentAggregators']),
    getSiteUrls: (metaSiteId?: string | null) => stableKey(['api', 'getSiteUrls', metaSiteId]),
    getAcceptPaymentsSetup: (metaSiteId?: string | null) =>
      stableKey(['api', 'getAcceptPaymentsSetup', metaSiteId]),
  },
} as const;
